import { useMemo, useState } from "react";
import { MainLayoutSelectOption } from "types/generic";

type GoAiguaSelectProps<OptionsType> = {
    options?: MainLayoutSelectOption<OptionsType>[];
    selectedOption: OptionsType | undefined;
    setSelectedOption: (optionValue: OptionsType) => void;
    placeholder?: string;
};

function MainLayoutSelect<OptionsType>(
    props: GoAiguaSelectProps<OptionsType>
): JSX.Element {
    const [isBoxFocused, setIsBoxFocused] = useState(false);
    const [isHeadFocused, setIsHeadFocused] = useState(false);

    const boxEventHandlers = useMemo(
        () => ({
            onFocus: () => setIsBoxFocused(true),
            onBlur: () => {
                setTimeout(() => setIsBoxFocused(false), 50);
            },
        }),
        []
    );

    const headEventHandlers = useMemo(
        () => ({
            onFocus: () => setIsHeadFocused(true),
            onBlur: () => {
                setTimeout(() => setIsHeadFocused(false), 50);
            },
        }),
        []
    );

    const isBoxShown = () => {
        return isBoxFocused || isHeadFocused;
    };

    const generateOptionBoxClass = () => {
        if (isBoxShown() /* ? */) {
            return "c-goaigua-select__option-box";
        } else {
            return "c-goaigua-select__option-box --hidden";
        }
    };

    const displayTextOnHead = () => {
        if (props.options && props.selectedOption) {
            for (let index in props.options) {
                if (props.options[index].value === props.selectedOption) {
                    return (
                        <div
                            className="c-goaigua-select__text"
                            key={props.options[index].label}
                        >
                            {props.options[index].label}
                        </div>
                    );
                }
            }
            return null;
        } else {
            return (
                <div className="c-goaigua-select__text --placeholder">
                    {props.placeholder}
                </div>
            );
        }
    };

    const generateElementsFromOptions = () => {
        let res = [];
        if (props.options) {
            for (let index in props.options) {
                let baseClass = "c-goaigua-select__option";
                const currentOption = props.options[index];
                if (currentOption.value === props.selectedOption) {
                    baseClass += " --active";
                }
                res.push(
                    <div
                        className={baseClass}
                        onClick={() =>
                            props.setSelectedOption(currentOption.value)
                        }
                        key={currentOption.label}
                    >
                        {currentOption.label}
                    </div>
                );
            }
        }

        return res;
    };

    return (
        <div className="c-goaigua-select">
            <div
                tabIndex={0}
                className={
                    "c-goaigua-select__head" +
                    (isBoxShown() ? " --focused" : "")
                }
                {...headEventHandlers}
            >
                {displayTextOnHead()}
            </div>

            <div
                tabIndex={0}
                className={generateOptionBoxClass()}
                {...boxEventHandlers}
            >
                <div className="c-goaigua-select__option-list">
                    {generateElementsFromOptions()}
                </div>
            </div>
        </div>
    );
}

export default MainLayoutSelect;
